if (!customElements.get("product-bundle")) {
  class ComponentProductBundle extends HTMLElement {
    constructor() {
      super();
      this._loading = true;
      try {
        const configElement = this.querySelector("[data-bundle-configuration]");
        if (configElement) {
          this.configuration = JSON.parse(configElement.innerText);
        } else {
          console.error('data-bundle-configuration element not found!');
          return;
        }
      } catch (error) {
        console.error('Error parsing configuration:', error);
        return;
      }
      this.cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer");
      this.moneyFormat = document.body.getAttribute('data-money-format');
      this.bundleContent = this.querySelector("[data-bundle-content]");
      this.modal = this.querySelector("#BundleProductModal") || this.querySelector('modal-bundle-dialog:not(.additional-bundle-modal)');
      this.addVariantButtons = this.querySelectorAll("[data-add-variant]");
      this.quantity = this.querySelector("[data-bundle-quantity]");
      this.addToCart = this.querySelector("[data-add-to-cart]");
      this.setupAddToCartButtonDelegation();
      this.deliveryDuration = this.querySelector('[data-delivery-duration]');
      this.deliveryLoading = this.querySelector('[data-delivery-loading]');
      this.deliverySoldOut = this.querySelectorAll('[data-delivery-sold-out]');
      this.deliveryAvailable = this.querySelector('[data-delivery-available]');
      this.hiddenScrollToElement = document.querySelector('.ed-hidden-scroll-to-element');
      this.isDynamicBundle = this.querySelector('[data-is-dynamic-bundle]');
      this.dynamicBundles = this.querySelectorAll('.ed-refill-bundles .product-bundle__product');
      this.priceContainer = this.querySelector('.ed-price .price__container');
      document.addEventListener('bundle:cart:submit', this.handleAddToCart.bind(this));
      this.attachVariantButtons();
      this.init();
    }

    set loading(loading) {
      this._loading = loading;

      if (loading) {
        this.bundleContent.classList.add("hidden");
      } else {
        this.bundleContent.classList.remove("hidden");
        this.updateDeliveryInfo();
      }
    }

    get loading() {
      return this._loading;
    }

    attachVariantButtons() {
      this.addVariantButtons.forEach((variantAddButton) => {
        variantAddButton.addEventListener(
            "click",
            this.handleSelectProduct.bind(this)
        );
      });
    }

    async init() {
      this.fixedProductIds = [];
      this.errors = [];
      this.selectedProducts = [];
      this.updateAddToCartButton();
      if (this.hiddenScrollToElement) {
        this.scrollToSets();
      }
      if (this.isDynamicBundle && this.dynamicBundles.length > 0) {
        document.addEventListener('DOMContentLoaded', () => {
          this.dynamicBundles.forEach(bundle => this.setupBundleClick(bundle));
        });
      }
      document.addEventListener("click", (event) => {
        var tooltips = document.querySelectorAll(".tooltip");
        var isClickInsideTooltip = Array.from(tooltips).some(tooltip => tooltip.contains(event.target));
        var isClickOnLink = event.target.closest("[data-product-id]");
        if (!isClickInsideTooltip && !isClickOnLink) {
          var tooltips = document.querySelectorAll(".tooltip");
          tooltips.forEach(function (tooltip) {
            tooltip.style.display = "none";
          });
        }
      });
      document.querySelectorAll(".tooltip-container").forEach(container => {
        const link = container.querySelector(".more-info-link");
        const tooltip = container.querySelector(".tooltip");
        const showTooltip = () => {
          tooltip.style.display = "block";
        };
        const hideTooltip = () => {
          tooltip.style.display = "none";
        };
        link.addEventListener("mouseover", showTooltip);
        link.addEventListener("mouseout", hideTooltip);
        tooltip.addEventListener("mouseover", showTooltip);
        tooltip.addEventListener("mouseout", hideTooltip);
      });
      this.loading = false;
    }

    /**
     * ELBDEV
     * DYNAMIC BUNDLE METHODS
     **/

    setupBundleClick(bundle) {
      bundle.addEventListener('click', (event) => {
        if (event.target.closest('input[type="radio"]')) return;
        const radio = bundle.querySelector('input[type="radio"]');
        if (radio && !radio.checked) {
          radio.checked = true;
          const dynamicBundleSize = radio.value;
          const variantPrice = radio.dataset.variantPrice;
          const variantComparePrice = radio.dataset.variantComparePrice;
          const variantPriceRaw = radio.dataset.variantPriceRaw;
          const variantComparePriceRaw = radio.dataset.variantComparePriceRaw;
          const perPortionText = radio.dataset.portionsPerBundle;
          const porPortionContainer = this.querySelector('.double-text-with-icons');
          const variantUnitPrice = radio.dataset.variantUnitPrice;
          const variantUnitPriceMeasurement = radio.dataset.variantUnitPriceMeasurement;
          this.updateBundleContent(dynamicBundleSize);
          this.selectVariantImage(radio);
          if (porPortionContainer && perPortionText) {
            porPortionContainer.querySelector('.text-with-icon p').innerText = perPortionText;
          }
          if (variantPrice && variantComparePrice) {
            this.updatePrice(variantPrice, variantPriceRaw, variantComparePrice, variantComparePriceRaw, variantUnitPrice, variantUnitPriceMeasurement);
          } else if (variantPrice) {
            this.updatePrice(variantPrice, variantUnitPrice, variantUnitPriceMeasurement);
          }
          document.dispatchEvent(new CustomEvent('ed:memberr-cb:variant-change', {
            detail: { newPrice: radio.dataset.variantPriceCents }
          }));
          this._isValidCartAdd();
          this.updateAddToCartButton();
        }
        this.dynamicBundles.forEach(item => {
          if(event.currentTarget === item) {
            item.classList.add('selected');
          } else {
            item.classList.remove('selected');
          }
        })
      });
    }

    selectVariantImage(radio) {
      const variantId = radio.dataset.variantId;
      if (!variantId) return;
      
      const mainSlide = document.querySelector(`li.product__media-item[data-variant-id="${variantId}"]`);
      if (mainSlide) {
        const img = mainSlide.querySelector('img');
        if (img) {
          document.dispatchEvent(new CustomEvent('bulk-price:image-change', {
            detail: {
              imageSrc: img.src,
              imageSrcset: img.srcset || '',
              imageAlt: img.alt || ''
            }
          }));
          return;
        }
      }
      
      const thumbnailSlide = document.querySelector(`li.thumbnail-list__item[data-variant-id="${variantId}"]`);
      if (thumbnailSlide) {
        const img = thumbnailSlide.querySelector('img');
        if (img) {
          let imageSrc = img.src;
          let imageAlt = img.alt || '';
          
          imageSrc = imageSrc.replace(/_(\d+)x(\d*)\./, '_1500x.');
          
          let imageSrcset = '';
          if (imageSrc.includes('cdn.shopify.com')) {
            const urlParts = imageSrc.split('?');
            const baseUrl = urlParts[0].replace(/_\d+x\d*\./, '.');
            const urlParams = urlParts[1] ? '?' + urlParts[1] : '';
            const ext = baseUrl.match(/\.[^.]+$/)[0];
            const baseWithoutExt = baseUrl.replace(/\.[^.]+$/, '');
            imageSrcset = `${baseWithoutExt}_550x${ext}${urlParams} 550w, ${baseWithoutExt}_750x${ext}${urlParams} 750w, ${baseWithoutExt}_1100x${ext}${urlParams} 1100w, ${baseWithoutExt}_1500x${ext}${urlParams} 1500w`;
          }
          
          document.dispatchEvent(new CustomEvent('bulk-price:image-change', {
            detail: {
              imageSrc: imageSrc,
              imageSrcset: imageSrcset,
              imageAlt: imageAlt
            }
          }));
        }
      }
    }

    updatePrice(variantPrice, variantComparePriceRaw, variantComparePrice, variantPriceRaw, variantUnitPrice, variantUnitPriceMeasurement) {
      if (variantPrice && variantComparePrice) {
        const priceElement = this.priceContainer.querySelector('.price__sale');
        if (priceElement) {
          priceElement.querySelector('.price-item--sale').innerText = variantPrice;
          priceElement.querySelector('.price-item--regular').innerText = variantComparePrice;
          if (priceElement.querySelector('.total-savings-badge')) {
            priceElement.querySelector('.total-savings-badge').innerText = formatMoney(variantComparePriceRaw - variantPriceRaw, this.moneyFormat);
          }
        }
      } else if (variantPrice) {
        const priceElement = this.priceContainer.querySelector('.price__regular');
        if (priceElement) {
          priceElement.querySelector('.price-item--regular').innerText = variantPrice;
        }
      }

      if (variantUnitPrice && variantUnitPriceMeasurement) {
        const unitPriceContainer = this.priceContainer.querySelector('.unit-price');
        if (unitPriceContainer) {
          const unitPriceElement = unitPriceContainer.querySelector('[data-ed-unit-price]');
          const measurementElement = unitPriceContainer.querySelector('.price-item--last span:last-child');
          if (unitPriceElement && measurementElement) {
            unitPriceElement.innerText = variantUnitPrice;
            measurementElement.innerText = variantUnitPriceMeasurement;
          }
        }
      }
    }

    updateBundleContent(dynamicBundleSize) {
      this.configuration.size = dynamicBundleSize;
      const bundleItems = this.bundleContent.querySelectorAll('.product-bundle__product');

      bundleItems.forEach(item => {
        const current = parseInt(item.getAttribute('data-current'), 10);
        if (current <= parseInt(dynamicBundleSize)) {
          item.classList.remove('hidden');
        } else {
          item.classList.add('hidden');
        }
        const selectedElements = this.bundleContent.querySelectorAll(
          '.product-bundle__product[data-type="selected"]:not(.hidden)[data-product-variant-id]'
        );

        this.selectedProducts = Array.from(selectedElements)
          .filter(el => el.getAttribute('data-product-variant-id').trim() !== '')
          .map(el => el.getAttribute('data-product-variant-id'));
      });
    }

    /**
     * END
     * DYNAMIC BUNDLE METHODS
     **/

    _isValidCartAdd() {
      // Only check bundle item slots, exclude flavor list items inside modal-bundle-dialog
      const scope = this.querySelector('[data-bundle-content]') || this;
      const typeDefaultProducts = scope.querySelectorAll(':scope > [data-type="default"]');
      const hasUnavailableProducts = scope.querySelectorAll(':scope > .product-bundle__product--unavailable').length > 0;

      if (typeDefaultProducts.length === 0 && !hasUnavailableProducts) return true;

      return !hasUnavailableProducts && this.selectedProducts.filter(v => v != null).length == parseInt(this.configuration.size);
    }

    cleanProductTitle(title) {
      return title
        .replace("Shakemahlzeit ", "")
        .replace("Balance Shake ", "")
        .replace("sostitutivo del pasto alla ", "")
        .replace("sostitutivo del pasto al ", "")
        .replace("Shake sostitutivo del pasto ", "")
        .replace("sostitutivo del pasto ", "")
        .replace("Cura dimagrante ", "")
        .replace("Abnehmkur ", "");
    }

    parseImageData(data) {
      if (typeof data === 'string') {
        try {
          return JSON.parse(data);
        } catch (e) {
          console.error("Failed to parse bundle_products_with_images:", e);
          return null;
        }
      }
      return data;
    }

    handleSelectProduct(e) {
      try {
        const productId = e.target.dataset.id || e.target.closest('[data-id]').dataset.id;
        const currentTarget = this.modal.dataset.currentItem;

        const bundleProduct = this.configuration.bundle_products.find(bp => bp.variants[0].id == productId);

        const targetContainer = this.querySelector(`.product-bundle__product[data-current="${currentTarget}"]`);

        const selectedProductContainer = targetContainer.querySelector("[data-selected-product]");
        selectedProductContainer.innerText = this.cleanProductTitle(bundleProduct.title);

        // Update product image (non-blocking — don't early-return if images data is missing)
        const bundleProductsWithImages = this.parseImageData(this.configuration.bundle_products_with_images);
        if (bundleProductsWithImages && Array.isArray(bundleProductsWithImages)) {
          const selectedProductImage = targetContainer.querySelector("img");
          const bundleProductWithImage = bundleProductsWithImages.find(p => p.id == bundleProduct.id);
          if (bundleProductWithImage?.fixed_image_preview_png) {
            selectedProductImage.src = bundleProductWithImage.fixed_image_preview_png;
          } else if (bundleProduct.featured_image) {
            selectedProductImage.src = bundleProduct.featured_image.src;
          }
        }

        targetContainer.dataset.type = "selected";
        targetContainer.dataset.productVariantId = productId;
        this.selectedProducts[parseInt(currentTarget) - 1] = productId;
        document.body.classList.remove("overflow-hidden");

        // Close the flavor modal
        if (typeof this.modal.hide === 'function') {
          this.modal.hide();
        } else {
          this.modal.removeAttribute("open");
        }
        // Belt-and-suspenders: force hide with inline style
        this.modal.style.display = 'none';

        // Also close any other open flavor modals inside this component
        this.querySelectorAll('.promo-bundle-popup__flavor-modal[open], modal-bundle-dialog[open]').forEach(m => {
          m.removeAttribute('open');
          m.style.display = 'none';
          if (typeof m.hide === 'function') m.hide();
        });

        this.updateAddToCartButton();
      } catch (err) {
        console.error('[handleSelectProduct] ERROR:', err);
      }
    }

    updateDeliveryInfo() {
      if (!this.deliveryLoading) return;
      const hasUnavailableFixedProduct = this.querySelectorAll('.product-bundle__product--unavailable[data-type="fixed"]').length > 0;
      const allProductsUnavailable = this.querySelectorAll('.product-bundle__product--unavailable').length === this.querySelectorAll('.product-bundle__product ').length;

      this.deliveryLoading.classList.add('hidden');

      if (allProductsUnavailable || hasUnavailableFixedProduct) {
        this.deliveryDuration.classList.add('sold-out');
        this.deliverySoldOut.forEach(e => e.classList.remove('hidden'));
        document.querySelectorAll(".bundle-button").forEach(e => e.classList.add("hidden"));
      } else {
        if (this.deliveryAvailable) this.deliveryAvailable.classList.remove('hidden');
      }
    }

    updateAddToCartButton() {
      const bundleDrawer = document.querySelector('#BundleDrawer');
      this.addToCart.disabled = bundleDrawer ? false : !this._isValidCartAdd();
      if (bundleDrawer) this.addToCart.classList.remove('loading');
      this.emitStickyAddToCartButtonState();
    }

    emitStickyAddToCartButtonState() {
      document.dispatchEvent(new CustomEvent('bundle:cart:update_submit', {
        bubbles: true,
        detail: { disabled: this.addToCart.disabled }
      }));
    }

    setupAddToCartButtonDelegation() {
      if (this.hasAddToCartListener) return;
      this.hasAddToCartListener = true;

      this.addEventListener('click', (e) => {
        const target = e.target.closest('[data-add-to-cart]');
        if (!target || target.disabled) return;

        e.preventDefault();
        e.stopPropagation();

        const drawer = document.querySelector('#BundleDrawer');
        drawer ? drawer.open() : this.handleAddToCart(e);
      }, true);
    }

    handleDrawerOpen(e) {
      e.preventDefault();
      document.querySelector('#BundleDrawer')?.open();
    }

    async handleAddToCart(e) {
      if (this._isValidCartAdd()) {
        this.addToCart.disabled = true;
        this.addToCart.querySelector('.loading-overlay__spinner').classList.remove('hidden');
        this.addToCart.classList.add('loading');
        this.emitStickyAddToCartButtonState();
        const config = fetchConfig();
        config.headers["X-Requested-With"] = "XMLHttpRequest";

        let items;
        try {
          items = this._collectItems();
          if (this.configuration.enable_sheko_cart_transform !== false) {
            await this._authorizeShekoBundle(items);
          }
        } catch (err) {
          this._appendError("handleAddToCart - bundle authorization", err);
          console.warn("Bundle authorization failed.", err);
          this.addToCart.disabled = false;
          this.addToCart.classList.remove('loading');
          this.addToCart.querySelector('.loading-overlay__spinner')?.classList.add('hidden');
          this.emitStickyAddToCartButtonState();
          return;
        }

        const formData = {
          items,
          sections: this.cart
              .getSectionsToRender()
              .map((section) => section.id),
          sections_url: window.location.pathname,
        };
        config.body = JSON.stringify(formData);

        fetch(`${routes.cart_add_url}`, config)
            .then(async (cartResponse) => {
              const response = await cartResponse.json();
              if (!cartResponse.ok) {
                throw new Error(response.description || response.message || 'Cart add failed.');
              }
              return response;
            })
            .then((response) => {
              const responseItems = Array.isArray(response.items)
                ? response.items
                : [response];
              const addedItem = responseItems.find(
                (item) => item.properties?.['_bundle'] == 'master'
              ) || responseItems[0] || {};

              try {
                this._bridgeNativeBundleAddToCart(formData.items, responseItems, addedItem);
              } catch (trackingError) {
                console.warn('Shopify bundle tracking bridge error:', trackingError);
              }
              try {
                this.handleDataLayer(formData.items, addedItem);
              } catch (trackingError) {
                console.warn('Bundle tracking error:', trackingError);
              }

              if (this.configuration.redirect_to_checkout) {
                window.location.href = "/checkout";
                return;
              }

              if (this.configuration.redirect_to_cart) {
                window.location.href = "/cart";
              } else {
                const sectionsFallback = () => {
                  return new Promise((resolve, reject) => {
                    const request = new XMLHttpRequest();

                    request.addEventListener('load', function() {
                      try {
                        const parsedResponse = JSON.parse(this.responseText);
                        resolve(parsedResponse);
                      } catch (err) {
                        reject(err);
                      }
                    });
                    
                    request.addEventListener('error', reject);

                    const sectionsQuery = formData.sections.join(',');

                    request.open('GET', `/?sections=${sectionsQuery}`, true);
                    request.send();
                  });
                };

                (async () => {
                  let sections = response.sections;

                  if (!sections) {
                    try {
                      const sectionsResponse = await sectionsFallback();
                      sections = sectionsResponse;
                    } catch (err) {
                      this._appendError("handleAddToCart - fallback", err);
                      console.warn("Failed to fetch sections fallback.", err);
                    }
                  }

                  this.cart.renderContents({
                    ...addedItem,
                    sections: sections || formData.sections,
                  });

                  this.addToCart.classList.remove('loading');
                  this.addToCart.querySelector('.loading-overlay__spinner').classList.add('hidden');

                  if (this.addToCart.dataset.success && this.addToCart.querySelector('.add-disallowed')) {
                      this.addToCart.classList.add('success');
                      this.addToCart.dataset.text = this.addToCart.querySelector('.add-allowed').innerText;
                      this.addToCart.querySelector('.add-disallowed').innerText = this.addToCart.dataset.success;
                      this.emitCartUpdate();
                      setTimeout(() => {
                        this.addToCart.querySelector('.add-disallowed').innerText = this.addToCart.dataset.text;
                        this.addToCart.classList.remove('success');
                      }, 1500);

                    }

                  const bundleDrawer = document.querySelector('#BundleDrawer');
                  if (bundleDrawer) {
                    this.addToCart.disabled = false;
                  }

                  // Close the promo popup dialog after successful add to cart
                  const promoDialog = this.closest('.promo-bundle-popup');
                  if (promoDialog) promoDialog.close();

                  this.reset();
                })();
              }
            })
            .finally(() => {
              this.cart.classList.contains('is-empty') ? this.cart.classList.remove('is-empty') : '';
            })
            .catch((err) => {
              this._appendError("handleAddToCart", err);
              console.warn("Something went wrong.", err);
            });
      }
    }

    _bridgeNativeBundleAddToCart(componentItems, responseItems, addedItem) {
      if (
        !Array.isArray(componentItems)
        || !Array.isArray(responseItems)
        || componentItems.length === responseItems.length
      ) {
        return false;
      }

      const analytics = window.ShopifyAnalytics;
      if (typeof analytics?.lib?.track !== 'function') return false;

      const firstProperties = componentItems[0]?.properties || {};
      const variantId = addedItem.variant_id
        || addedItem.id
        || firstProperties._shekoBundleParentVariantId
        || firstProperties._edBundleParentVariantId;
      if (!variantId) return false;

      const page = analytics.meta?.page || {};
      const cartToken = document.cookie
        .split('; ')
        .find((cookie) => cookie.startsWith('cart='))
        ?.split('=')
        .slice(1)
        .join('=');
      const manifestPrice = Number(firstProperties._shekoBundlePrice);
      const responsePrice = Number(addedItem.presentment_price);
      const eventProperties = {
        ...(cartToken ? { cartToken: decodeURIComponent(cartToken) } : {}),
        variantId: String(variantId),
        productId: addedItem.product_id || this.configuration.product?.id,
        currency: addedItem.currency
          || analytics.meta?.currency
          || window.Shopify?.currency?.active,
        quantity: String(
          addedItem.quantity
          || firstProperties._shekoBundleQuantity
          || this.quantity?.value
          || 1
        ),
        price: Number.isFinite(responsePrice) ? responsePrice : manifestPrice,
        name: addedItem.title || addedItem.product_title || this.configuration.product?.title,
        sku: addedItem.sku || firstProperties._bundleSku || this.configuration.sku,
        brand: addedItem.vendor || this.configuration.product?.vendor,
        variant: addedItem.variant_title || '',
        category: addedItem.product_type || this.configuration.product?.type,
        remote: addedItem.remote || null,
        ...(page.pageType ? { pageType: page.pageType } : {}),
        ...(page.resourceType ? { resourceType: page.resourceType } : {}),
        ...(page.resourceId ? { resourceId: page.resourceId } : {}),
      };

      analytics.lib.track(
        'Added Product',
        eventProperties,
        undefined,
        undefined,
        {
          addApiSource: 'add-fetch-bulk-cart-transform-bridge',
          shopifyEmitted: true,
        }
      );
      return true;
    }

    async _authorizeShekoBundle(items) {
      const components = items.filter((item) => item.properties?._shekoBundleId);
      if (components.length < 2) {
        throw new Error('No complete SHEKO bundle was collected.');
      }
      const template = components[0];
      const bundleId = String(template.properties._shekoBundleId || '');
      const parentVariantId = String(template.properties._shekoBundleParentVariantId || '');
      const bundleQuantity = parseInt(this.quantity.value, 10);
      const manifestUrl = this.configuration.bundle_manifest_url
        || '/apps/sheko-sales-analytics/bundle-manifest';
      const response = await fetch(manifestUrl, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({
          contractVersion: 4,
          bundleId,
          parentVariantId,
          bundleQuantity,
          components: components.map((item) => ({
            variantId: item.id,
            quantity: item.quantity,
          })),
        }),
      });
      const manifest = await response.json().catch(() => ({}));
      if (
        !response.ok
        || manifest.version !== 4
        || typeof manifest.signature !== 'string'
        || typeof manifest.sku !== 'string'
        || typeof manifest.price !== 'string'
        || !/^\d{1,12}(?:\.\d{1,6})?$/.test(manifest.price)
        || typeof manifest.currencyCode !== 'string'
        || !/^[A-Z]{3}$/.test(manifest.currencyCode)
        || !/^\d{4}-\d{2}-\d{2}$/.test(manifest.validDate || '')
        || !/^[A-Za-z0-9-]{8,64}$/.test(manifest.keyId || '')
      ) {
        throw new Error(manifest.error || 'Bundle manifest request failed.');
      }
      components.forEach((item) => {
        item.properties._shekoBundleQuantity = bundleQuantity;
        item.properties._shekoBundleSignature = manifest.signature;
        item.properties._shekoBundleValidDate = manifest.validDate;
        item.properties._shekoBundleKeyId = manifest.keyId;
        item.properties._shekoBundlePrice = manifest.price;
        item.properties._shekoBundleShopCurrency = manifest.currencyCode;
        item.properties._bundleSku = manifest.sku;
      });
    }

    emitCartUpdate() {
      fetch('/cart.js')
        .then(response => response.json())
        .then(response => {
          document.dispatchEvent(new CustomEvent('cart-quantity-updated', { bubbles: true, detail: response }));
        });
    }

    _collectItems() {
      const items = [];
      const selectedProducts = [];
      const componentProductIds = [...this.selectedProducts];
      let selectedProductIds = [];
      const bundleInfo = {};
      const bundleId = globalThis.crypto?.randomUUID?.()
        || `${Date.now()}-${Math.random().toString(36).slice(2, 12)}`;
      const selectedBundleRadio = this.querySelector('input[type="radio"]:checked');
      const parentVariantId = parseInt(
        selectedBundleRadio?.dataset.variantId || this.configuration.id,
        10
      );
      const configuredVariants = Array.isArray(this.configuration.product?.variants)
        ? this.configuration.product.variants
        : [];
      const selectedParentVariant = configuredVariants.find(
        (variant) => parseInt(variant.id, 10) === parentVariantId
      );
      const selectedVariantConfiguration = this.configuration.variants_map?.[parentVariantId];
      const bundleSku = selectedParentVariant?.sku
        || selectedVariantConfiguration?.sku
        || this.configuration.sku
        || '';
      const bundlePrice = selectedParentVariant?.price
        || selectedVariantConfiguration?.price
        || this.configuration.ed_bundle_price;

      if (this.configuration.fixed_products && this.configuration.fixed_products.length) {
        this.configuration.fixed_products.forEach((fixedProduct) => {
          componentProductIds.push(fixedProduct.variants[0].id);
          if (bundleInfo[fixedProduct.variants[0].id] == undefined) {
            bundleInfo[fixedProduct.variants[0].id] = parseInt(this.quantity.value);
          } else {
            bundleInfo[fixedProduct.variants[0].id] += parseInt(this.quantity.value);
          }
        });
      }
      const sumQuantities = {};
      componentProductIds.forEach((productId) => {
        if (sumQuantities[productId] === undefined) {
          sumQuantities[productId] = 1;
        } else {
          sumQuantities[productId] += 1;
        }
      });
      if (this.configuration.bundle_products ) {
        componentProductIds.forEach((productId) => {
          let bundleProduct = this.configuration.bundle_products.find(
              (bundleProduct) => bundleProduct.variants[0].id == productId
          );
          if (bundleProduct == undefined) {
            bundleProduct = this.configuration.fixed_products.find(
                (bundleProduct) => bundleProduct.variants[0].id == productId
            );
          }
          selectedProducts.push(`${bundleProduct.title}`);

          if(bundleProduct.variants?.length > 0) {
            selectedProductIds.push(bundleProduct.variants[0].id);
          }
        });
      }
      Object.keys(sumQuantities).forEach((productId) => {
        bundleInfo[productId] = parseInt(sumQuantities[productId]) * parseInt(this.quantity.value);
      });

        // ELBDEV: fix for products without bundle_products
        if (!this.configuration.bundle_products && componentProductIds.length > 0) {
            componentProductIds.forEach(fixedProduct => {
                selectedProductIds.push(fixedProduct);
            });
        }

      // ELBDEV: GET SELECTED VARIANT IDS AND INSERT THEM INTO THE MASTER PROPERTY
      selectedProductIds = selectedProductIds.join(',');
      const masterProperties = {
        _bundle: "master",
        _token: this.configuration.token,
        _hash: this.configuration.hash,
        _selected: selectedProducts,
        _bundleInfo: bundleInfo,
        _bundleSku: bundleSku,
        _edBundleItems: selectedProductIds,
        _edBundleMasterId: parentVariantId,
        _edBundleId: bundleId,
        _edBundleMasterQty: parseInt(this.quantity.value),
      };

      // elbDev handle case where no selected products are available
      const itemCount = selectedProducts.length > 0
        ? selectedProducts.length
        : this.configuration.fixed_products.length;
      masterProperties._bundleItemCount = itemCount * parseInt(this.quantity.value);

      if (this.errors.length) {
        masterProperties['_errors'] = this.errors.join(' - ');
      }

      // The SHEKO integration is enabled by default. An explicit false keeps a
      // per-section emergency opt-out without requiring template migrations.
      const useShekoCartTransform = this.configuration.enable_sheko_cart_transform !== false;
      const enableLegacyCheckoutExtension = this.configuration.enable_checkout_extension === true;
      const enableLegacyBundleV2 = this.configuration.enable_checkout_extension_v2 === true;

      if (!useShekoCartTransform && (enableLegacyBundleV2 || !enableLegacyCheckoutExtension)) {
        items.push({
          quantity: parseInt(this.quantity.value),
          id: parentVariantId,
          properties: masterProperties,
        });
      }

      const componentItems = useShekoCartTransform
        ? componentProductIds.map((productId, index) => ({
            productId,
            quantity: parseInt(this.quantity.value),
            componentId: `${bundleId}-${index + 1}`,
          }))
        : Object.entries(sumQuantities).map(([productId, quantity]) => ({
            productId,
            quantity: parseInt(quantity) * parseInt(this.quantity.value),
            componentId: '',
          }));

      componentItems.forEach(({ productId, quantity, componentId }) => {
        const item = {
          quantity,
          id: parseInt(productId),
          properties: {
            _bundle: "item",
            _token: this.configuration.token,
            _hash: this.configuration.hash,
            _checkout_hidden: true,
          },
        };

        /** NEW BUNDLE PROPERTIES BY ELBDEV **/
        if (useShekoCartTransform) {
          // Keep the legacy keys while also emitting the SHEKO cart-transform
          // contract. Every component must share the same group and parent.
          item.properties._edBundleId = bundleId;
          item.properties._edBundleParentVariantId = parentVariantId;
          item.properties._shekoBundleId = bundleId;
          item.properties._shekoBundleParentVariantId = parentVariantId;
          item.properties._shekoBundleComponentId = componentId;
          item.properties._edBundlePrice = bundlePrice;
          item.properties._edBundleQuantity = parseInt(this.quantity.value);
          item.properties._bundleSku = bundleSku;
          item.properties._handle = this.configuration.handle;
        } else if (enableLegacyCheckoutExtension) {
          item.properties._edBundleId = bundleId;
          item.properties._edBundleParentVariantId = parentVariantId;
          item.properties._edBundlePrice = bundlePrice;
          item.properties._edBundleQuantity = parseInt(this.quantity.value);
          item.properties._bundleSku = bundleSku;
          item.properties._handle = this.configuration.handle;
        }

        if (useShekoCartTransform || !enableLegacyBundleV2) {
          items.push(item);
        }
      });
      return items;
    }

    scrollToSets() {
      // elbDev - scroll to first unselected set
      this.hiddenScrollToElement.addEventListener('click', () => {
        // select only non fixed products
        const allProducts = this.querySelectorAll('.product-bundle__product');
        const selectableProducts = Array.from(allProducts).filter(function(product) {
          return product.getAttribute('data-type') !== 'fixed';
        });

        // scroll to first unselected product
        for (let product of selectableProducts) {
          if (product.getAttribute('data-type') !== 'selected') {
            const yOffset = product.getBoundingClientRect().top + window.pageYOffset - 200;
            window.scrollTo({ top: yOffset, behavior: 'smooth' });
            break;
          }
        }
      });
    }

    async reset() {
      this.loading = true;
      const sectionUrl = new URL(window.location.pathname, window.location.origin);
      sectionUrl.searchParams.set('section_id', this.dataset.sectionId);
      await fetch(sectionUrl.toString())
          .then(response => response.text())
          .then(async response => {
            const newSection = new DOMParser().parseFromString(response, 'text/html').querySelector("[data-bundle-content]");
            if(newSection && newSection.innerHTML) {
              this.querySelector("[data-bundle-content]").innerHTML = newSection.innerHTML;
              //this.skeleton = this.querySelector("[data-skeleton]");
              this.fixedProductWrapper = this.querySelector("[data-fixed-product]");
              this.bundleContent = this.querySelector("[data-bundle-content]");
              if (this.isDynamicBundle && this.dynamicBundles.length > 0 && this.dynamicBundles[0].querySelector('input[type="radio"]')) {
                this.dynamicBundles[0].querySelector('input[type="radio"]').checked = true;
              }
              await this.refreshHash();
              this.attachVariantButtons();
              this.init();

              const bundleDrawer = document.querySelector('#BundleDrawer');
              if (bundleDrawer) {
                this.addToCart.disabled = false;
              }
            }
          });
    }

    handleDataLayer(formData, addedItem = {}) {
      const componentItems = Array.isArray(formData) ? formData : [];
      if (!componentItems.length) return;

      const firstComponent = componentItems[0] || {};
      const properties = firstComponent.properties || {};
      const bundleId = properties._shekoBundleId
        || properties._edBundleId
        || globalThis.crypto?.randomUUID?.()
        || Date.now() + '-' + Math.random().toString(36).slice(2, 12);
      const parentVariantId = Number(
        properties._shekoBundleParentVariantId
        || properties._edBundleParentVariantId
        || addedItem.variant_id
        || this.configuration.id
      );
      const quantity = Number(
        properties._shekoBundleQuantity
        || properties._edBundleQuantity
        || this.quantity?.value
        || 1
      );
      const eventId = 'bundle_add_' + bundleId;
      const currency = addedItem.currency
        || window.Shopify?.currency?.active
        || properties._shekoBundleShopCurrency
        || 'EUR';
      const responseValue = Number(addedItem.final_line_price ?? addedItem.line_price);
      const manifestUnitPrice = Number(properties._shekoBundlePrice || 0);
      const value = Number.isFinite(responseValue)
        ? responseValue / 100
        : manifestUnitPrice * quantity;
      const product = this.configuration.product || {};
      const variants = Array.isArray(product.variants)
        ? product.variants
        : Object.values(product.variants || {});
      const parentVariant = variants.find(
        (variant) => Number(variant.id) === parentVariantId
      ) || {};
      const productId = Number(addedItem.product_id || product.id);
      const item = {
        item_id: 'shopify_' + (window.Shopify?.country || 'DE') + '_' + productId + '_' + parentVariantId,
        item_name: addedItem.product_title || product.title || 'Bundle',
        item_brand: addedItem.vendor || product.vendor || '',
        item_category: addedItem.product_type || product.type || '',
        item_variant: addedItem.variant_title || parentVariant.title || '',
        currency,
        price: quantity > 0 ? value / quantity : value,
        quantity,
        bundle_id: bundleId,
        bundle_component_count: componentItems.length,
      };
      const eventPayload = {
        event_id: eventId,
        bundle_id: bundleId,
        parent_variant_id: parentVariantId,
        component_count: componentItems.length,
        ecommerce: {
          currency,
          value,
          items: [item],
        },
        components: componentItems.map((component) => ({
          variant_id: Number(component.id),
          quantity: Number(component.quantity || 1),
        })),
      };

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'add_to_cart',
        ...eventPayload,
      });

      if (window.Shopify?.analytics?.publish) {
        window.Shopify.analytics.publish(
          'sheko_bundle_added_to_cart',
          eventPayload
        );
      } else {
        console.warn('Shopify custom pixel bridge is unavailable.');
      }
    }
    async refreshHash() {
      try {
        await fetch(`${window.location.pathname}?view=hash`)
            .then(response => response.json())
            .then(response => {
              this.configuration.hash = response.hash;
              this.configuration.token = response.token;
            })
      } catch (e) {
        console.error(e);
      }
    }

    _appendError(type, err) {
      try {
        let error_data = {
          type: type,
          date: new Date(),
          navigator: {
            userAgent: navigator.userAgent,
            appVersion: navigator.appVersion,
            language: navigator.language,
            platform: navigator.platform,
            connection: {
              downlink: navigator.connection.downlink,
              effectiveType: navigator.connection.effectiveType
            }
          },
          location: window.location,
          url: routes.cart_add_url,
          config: {
            ...config,
            body: JSON.parse(config.body)
          },
          error: {
            message: err.message,
            stack: err.stack,
            err: err
          }
        }
        let base64_error_string = encodeURIComponent(btoa(JSON.stringify(error_data)));
        // let parsed_base64_error = JSON.parse(atob(decodeURIComponent(base64_error_string)));
        this.errors.push(base64_error_string);
      } catch(e) {
        this.errors.push(`_appendError Exception: ${e.message}`);
      }
    }
  }

  customElements.define("product-bundle", ComponentProductBundle);
}
